import faqEn from './faqEn';
import headerEn from './headerEn';
import footerEn from './footerEn';
import homeEn from './homeEn';
import prescriptiondiscountEn from './prescriptiondiscountEn';
import loginEn from './loginEn';
import membercenterEn from './membercenterEn';
import accountsettingEn from './accountsettingEn';
import bonussavingFAQEn from './bonussavingFAQEn';
import howitworksEn from './howitworksEn';
import aboutusEn from './aboutusEn';
import browseprescriptionEn from './browseprescriptionEn';
import signupEn from './signupEn';
import drugpopupEn from './drugpopupEn';
import specialtydrugEn from './specialtydrugEn';
import singlecareEn from './singlecareappEn.json';
import drugbasketEn from './drugbasketEn';
import presciptionEn from './prescriptionEn/presciptionEn';
import priceAleartEn from './prescriptionEn/priceAleartEn';
import couponModalEn from './prescriptionEn/couponModalEn';
import pfizerModalEn from './prescriptionEn/pfizerModalEn';
import constanEn from './constantEn';
import discountSavingsSectionEn from './discountSavingsSectionEn';
import forgotPasswordEn from './forgotPasswordEn.json';
import authenticatemodalEn from './authenticatemodalEn';
import enterpasswordModalEn from './enterpasswordmodalEn';
import signuphomedeliveryEn from './signuphomedeliveryEn';
import emailsentmodalEn from './emailsentmodalEn';
import notFoundEn from './notFoundEn';
import altTextEn from './altTextEn';
import prescriptionDeliveryEn from './prescriptionDeliveryEn';
import FamilywizeFaqEn from './FamilywizeFaqEn';
import conditionsEN from './conditionsEN.json';
import partnersEn from './partnersEn.json';
import medicareEn from './medicareEn.json';
import referralSuccessEn from './referralSuccessEn.json';
import deleteAccounEn from './deleteAccountEn.json';
import signupLandingEn from './signupLandingEn.json';
import homeNewEn from './homeNewEn.json';
import factCheckModalEn from './FactCheckModalEn.json';
import washingtonPrivacyPolicyEn from './washingtonPrivacyPolicyEn.json';
export const translationEN = {
  'applies to any eligible offer below': 'applies to any eligible offer below',
  'You have': 'You have',
  'in bonus savings': 'in bonus savings',
  'available.': ' available.',
  'Type your drug name': 'Type your drug name',
  'ada suggestion drug message':
    'Suggestions are available. Use the up and down arrow keys to browse through the auto-suggestions.',
  Search: 'Search',
  'Oops, there are no results for the term':
    'Oops, there are no results for the term',
  'Enter zip': 'Enter zip',
  in: 'in',
  ...faqEn,
  ...headerEn,
  ...footerEn,
  ...homeEn,
  ...prescriptiondiscountEn,
  ...loginEn,
  ...membercenterEn,
  ...accountsettingEn,
  ...bonussavingFAQEn,
  ...howitworksEn,
  ...aboutusEn,
  ...browseprescriptionEn,
  ...signupEn,
  ...presciptionEn,
  ...constanEn,
  ...priceAleartEn,
  ...couponModalEn,
  ...pfizerModalEn,
  ...drugpopupEn,
  ...browseprescriptionEn,
  ...drugbasketEn,
  ...discountSavingsSectionEn,
  ...specialtydrugEn,
  ...forgotPasswordEn,
  ...authenticatemodalEn,
  ...enterpasswordModalEn,
  ...signuphomedeliveryEn,
  ...emailsentmodalEn,
  ...notFoundEn,
  ...altTextEn,
  ...singlecareEn,
  ...prescriptionDeliveryEn,
  ...FamilywizeFaqEn,
  ...conditionsEN,
  ...partnersEn,
  ...medicareEn,
  ...referralSuccessEn,
  ...deleteAccounEn,
  ...signupLandingEn,
  ...homeNewEn,
  ...factCheckModalEn,
  ...washingtonPrivacyPolicyEn
};
